import { render } from "../../../core/components/info-dialog/info-dialog-template.html?vue&type=template&id=1134306c&external"
import script from "../../../core/components/info-dialog/info-dialog-scripts.js?vue&type=script&lang=js&external"
export * from "../../../core/components/info-dialog/info-dialog-scripts.js?vue&type=script&lang=js&external"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.39_vue@3.5.39_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__